import { useEffect, useState } from "react";

import useCustomSelector from "../../../redux/hooks/useCustomSelector";
import useActionCreator from "../../../redux/hooks/useActionCreator";

import { DemandState } from "@reducers/types/procurements/demand-state";
import { useLocation } from "react-router-dom";
import { ROUTES } from "@constants/routes";

interface UseDemandList {
  demandState: DemandState;
  handleQuery: (key: string, value: number | string) => void;
}

export const useDemandList = (): UseDemandList => {
  const { demandFetchActionHandler } = useActionCreator();
  const { pathname } = useLocation();

  const [query, setQuery] = useState({
    page: 1,
    size: 10,
    search: "",
    status:
      pathname === `${ROUTES.PROCUREMENT.PROCUREMENTS}/${ROUTES.CREATE}`
        ? "PENDING"
        : null,
  });

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const demandState = useCustomSelector(
    (store) => store.procurements.demandState,
  );

  useEffect(() => {
    demandFetchActionHandler(query);
  }, [query]);

  return {
    handleQuery,
    demandState,
  };
};
